import {
  Button,
  Flex,
  Form,
  FormInstance,
  Input,
  Modal,
  Typography,
} from 'antd';
import { SuggestionStatus } from '../../types';

const SuggestionReviewDrawerHeader = ({
  onReject,
  onApprove,
  title,
  name,
  form,
  onConfirm,
  reviewResult,
  modalVisible,
  onModalClose,
}: {
  onReject: () => void;
  onApprove: () => void;
  title: string;
  name: string;
  onConfirm: () => void;
  form: FormInstance;
  reviewResult: SuggestionStatus;
  modalVisible: boolean;
  onModalClose: () => void;
}) => {
  const reviewResultTitle =
    reviewResult === SuggestionStatus.APPROVED
      ? 'Approved Reason'
      : 'Rejected Reason';

  return (
    <Flex justify="space-between">
      <Flex vertical gap={2}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        <Typography.Text type="success">{name}</Typography.Text>
      </Flex>
      <Flex gap={24} align="center">
        <Button color="red" variant="filled" onClick={onReject}>
          Reject
        </Button>
        <Button color="green" variant="filled" onClick={onApprove}>
          Accept and Save
        </Button>
      </Flex>
      <Modal
        open={modalVisible}
        onOk={onConfirm}
        onClose={onModalClose}
        onCancel={onModalClose}
        title={reviewResultTitle}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="suggestionReviewDescription"
            // rules={[
            //   {
            //     required: false,
            //     message: 'Please provide a reason for rejection',
            //   },
            // ]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>
        </Form>
      </Modal>
    </Flex>
  );
};

export default SuggestionReviewDrawerHeader;
